import type { App } from 'vue'

import { createMongoAbility } from '@casl/ability'
import { abilitiesPlugin } from '@casl/vue'
import type { Rule } from './ability'

export default function (app: App) {

  const userFunctionalityRules = useCookie<{ [key: string]: string[] }>('userAbilityRules')

  const userAbilityRules: Rule[] = []

  if (userFunctionalityRules.value) {
    for (const [key, actions] of Object.entries(userFunctionalityRules.value)) {
      actions.forEach((action: string) => {
        userAbilityRules.push({ action: action.toString(), subject: key.toString() });
      });
    }
  }

  const initialAbility = createMongoAbility(userAbilityRules ?? [])

  app.use(abilitiesPlugin, initialAbility, {
    useGlobalProperties: true,
  })
}
